// extracted by mini-css-extract-plugin
export var btn = "footerMedium-module--btn--3ee7b";
export var buttonMd = "footerMedium-module--button-md--5fc96";
export var contacts = "footerMedium-module--contacts--77f7b";
export var euro = "footerMedium-module--euro--fec25";
export var fBtn = "footerMedium-module--f-btn--5461b";
export var footer = "footerMedium-module--footer--b402c";
export var footerMedium = "footerMedium-module--footerMedium--8b4a9";
export var footerMedium__row = "footerMedium-module--footerMedium__row--8818a";
export var footerMedium__text = "footerMedium-module--footerMedium__text--257da";
export var footer__blockAbout = "footerMedium-module--footer__block-about--d98cf";
export var footer__blockLink1 = "footerMedium-module--footer__block-link-1--51c0f";
export var footer__blockLink2 = "footerMedium-module--footer__block-link-2--4a054";
export var footer__blockPartnership = "footerMedium-module--footer__block-partnership--c9088";
export var footer__box = "footerMedium-module--footer__box--3c87c";
export var footer__formSection = "footerMedium-module--footer__form-section--06d9c";
export var footer__info = "footerMedium-module--footer__info--0d9c2";
export var footer__license = "footerMedium-module--footer__license--dab69";
export var footer__licenseInfo = "footerMedium-module--footer__license-info--2ee2e";
export var footer__list = "footerMedium-module--footer__list--fdc59";
export var footer__listSection = "footerMedium-module--footer__list-section--fc06b";
export var footer__listSectionListTitle = "footerMedium-module--footer__list-section--list-title--9d42a";
export var footer__listSectionTitle = "footerMedium-module--footer__list-section--title--157b6";
export var footer__logo = "footerMedium-module--footer__logo--08762";
export var footer__mainInfo = "footerMedium-module--footer__main-info--b83c9";
export var footer__rights = "footerMedium-module--footer__rights--09bd0";
export var footer__shareBtn = "footerMedium-module--footer__share-btn--a67bf";
export var footer__shareText = "footerMedium-module--footer__share-text--65b83";
export var footer__siteMap = "footerMedium-module--footer__site-map--aef26";
export var footer__social = "footerMedium-module--footer__social--cfa39";
export var footer__tel = "footerMedium-module--footer__tel--1fe80";
export var info = "footerMedium-module--info--248a9";
export var licenses = "footerMedium-module--licenses--6bdae";
export var social = "footerMedium-module--social--e3874";
export var tgTrainings = "footerMedium-module--tg-trainings--77723";
export var yaShare2__badge = "footerMedium-module--ya-share2__badge--caeeb";
export var yaShare2__container = "footerMedium-module--ya-share2__container--056ec";
export var yaShare2__container_colorScheme_blackwhite = "footerMedium-module--ya-share2__container_color-scheme_blackwhite--ce8b2";
export var yaShare2__container_shape_round = "footerMedium-module--ya-share2__container_shape_round--69ebc";
export var yaShare2__container_size_s = "footerMedium-module--ya-share2__container_size_s--fe898";
export var yaShare2__icon = "footerMedium-module--ya-share2__icon--b05c3";
export var yaShare2__icon_copy = "footerMedium-module--ya-share2__icon_copy--f2550";
export var yaShare2__icon_messengerContact = "footerMedium-module--ya-share2__icon_messenger-contact--77ab9";
export var yaShare2__icon_more = "footerMedium-module--ya-share2__icon_more--9b098";
export var yaShare2__item = "footerMedium-module--ya-share2__item--2f394";
export var yaShare2__list = "footerMedium-module--ya-share2__list--92fd2";
export var yaShare2__list_direction_horizontal = "footerMedium-module--ya-share2__list_direction_horizontal--4fafa";
export var yaShare2__mobilePopupBadge = "footerMedium-module--ya-share2__mobile-popup-badge--def96";